const Layout = () => import('@/layout/index.vue')

export default {
    path: '/member-purchase',
    component: Layout,
    redirect: '/member-purchase/index',
    name: 'MemberPurchase',
    meta: {
        title: '会员兑换',
        icon: 'personal-member',
        defaultOpened: true,
        exchangeEntry: true
    },
    children: [
        {
            path: 'index',
            name: 'memberPurchaseIndex',
            component: () => import('@/views/memberPurchase/index.vue'),
            meta: {
                title: '会员兑换',
                sidebar: false,
                breadcrumb: false,
                activeMenu: '/member-purchase',
                exchangeEntry: true
            }
        }
    ]
}
